import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-028890e5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "tab" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "indicator-wrapper" };
const _hoisted_5 = { class: "button-wrapper" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Clear terminal", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Indicator = _resolveComponent("Indicator");
    const _component_Bin = _resolveComponent("Bin");
    const _component_Arrow = _resolveComponent("Arrow");
    const _component_Terminal = _resolveComponent("Terminal");
    return (_openBlock(), _createElementBlock("div", {
        ref: "terminalWrapper",
        class: "terminal-wrapper",
        style: _normalizeStyle(_ctx.terminalWrapperStyles)
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                ref: "resizer",
                class: "resizer",
                style: _normalizeStyle(_ctx.resizerStyles)
            }, null, 4),
            _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTerminals, (terminal) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: terminal.name,
                        class: _normalizeClass(["tab-item", _ctx.pipelineSpanClasses(terminal.name)]),
                        onClick: ($event) => (_ctx.toggleTerminalPanel(terminal.name))
                    }, [
                        _createElementVNode("span", {
                            class: _normalizeClass(_ctx.pipelineSpanClasses(terminal.name))
                        }, _toDisplayString(terminal.name), 3),
                        _createElementVNode("div", _hoisted_4, [
                            (terminal.hasNewMessage)
                                ? (_openBlock(), _createBlock(_component_Indicator, {
                                    key: 0,
                                    color: _ctx.terminalIndicatorColor(terminal.hasNewMessage)
                                }, null, 8, ["color"]))
                                : _createCommentVNode("", true)
                        ])
                    ], 10, _hoisted_3));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
                (_ctx.isTerminalPanelOpened)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.clearTerminalOutput(_ctx.activeTerminal)))
                    }, [
                        _createVNode(_component_Bin),
                        _hoisted_6
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = () => { _ctx.arrowHovered = false; _ctx.toggleTerminalPanel(undefined); }),
                    onMouseenter: _cache[2] || (_cache[2] = ($event) => (_ctx.arrowHovered = true)),
                    onMouseleave: _cache[3] || (_cache[3] = ($event) => (_ctx.arrowHovered = false))
                }, [
                    (!_ctx.isTerminalPanelOpened)
                        ? (_openBlock(), _createBlock(_component_Arrow, {
                            key: 0,
                            color: "white",
                            scale: "small",
                            rotate: "up",
                            hover: _ctx.arrowHovered
                        }, null, 8, ["hover"]))
                        : (_openBlock(), _createBlock(_component_Arrow, {
                            key: 1,
                            color: "white",
                            scale: "small",
                            rotate: "left",
                            hover: _ctx.arrowHovered
                        }, null, 8, ["hover"]))
                ], 32)
            ])
        ]),
        _withDirectives(_createVNode(_component_Terminal, { terminalInstance: _ctx.activeTerminal }, null, 8, ["terminalInstance"]), [
            [_vShow, _ctx.isTerminalPanelOpened]
        ])
    ], 4));
}
